<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-27 15:52:21
 * @LastEditors: shenlin
 * @LastEditTime: 2022-10-13 14:08:26
-->
<template>
  <div class="app-container">
    <div class="header">
      <div class="header-serach">
        <el-form :inline="true" :model="ruleform">
          <el-form-item label="">
            <el-input
              v-model="ruleform.searchKey"
              placeholder="请输入通知公告标题"
              @keyup.enter.native="getSearch"
            >
              <i
                @click="getSearch"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i
            ></el-input>
          </el-form-item>
          <el-form-item label="发布状态：">
            <el-select
              v-model="ruleform.isDeploy"
              placeholder="请选择"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in IndustryList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间：">
            <el-date-picker
              v-model="timeInterval"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="getPoss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="所属区域：" v-if="isCounty !== '区域管理员'">
            <el-select
              v-model="ruleform.areaCode"
              placeholder="请选择区域"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in areaList"
                :key="item.code"
                :label="item.county"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="container-title">
      <div>
        共检索到 <b>{{ totalRecord }}</b> 条通知公告
      </div>
      <div class="container-btn">
        <el-button
          class="addPru"
          @click="exportList"
          :loading="exportLoading"
          :disabled="isDisabled"
          >{{ exportName }}</el-button
        >
        <el-button type="primary" @click="addNotice">新增</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      ref="multipleTable"
      @selection-change="handleSelectionChange"
      :header-cell-style="{ background: '#fafafa' }"
      height="500"
    >
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column type="index" label="序号" width="55" align="center">
      </el-table-column>
      <el-table-column
        prop="informTitle"
        label="通知公告标题"
        width="320"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div class="cement_title" @click="detailNotice(scope.row)">
            <!-- <i v-if="scope.row.topStatus === 1"></i> -->
            <div v-if="pageNum === 1 && scope.row.topStatus === 1">
              置顶
            </div>
            {{ scope.row.informTitle }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="isDeploy" label="发布状态" align="center">
        <template slot-scope="scope">
          <span
            v-if="scope.row.isDeploy == 1"
            style="
                width: 8px;
                height: 8px;
                background: rgb(14,119,209);
                display: inline-block;
                border-radius: 50%;
              "
          ></span>
          <span
            v-else
            style="
                width: 8px;
                height: 8px;
                background: rgb(191,191,191);
                display: inline-block;
                border-radius: 50%;
              "
          ></span>
          {{ scope.row.isDeploy === 0 ? '未发布' : '已发布' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="creator"
        label="作者"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="county" label="所属区域" align="center">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.createTime | fromt }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <span
            class="btn"
            v-if="scope.row.topStatus === 0"
            @click="topInformNotice(scope.row, 1)"
            >置顶</span
          >
          <span v-else class="btn" @click="topInformNotice(scope.row, 0)"
            >取消置顶</span
          >
          <!-- <el-popover placement="top-start" width="100" trigger="click"> -->
          <!-- <span slot="reference" style="color: #1890ff; cursor: pointer"
              >发布</span
            > -->
          <el-popconfirm
            title="确定要发布该条通知公告吗"
            confirm-button-text="继续"
            v-if="scope.row.isDeploy === 0"
            icon="el-icon-info"
            @confirm="issueInformNotice(scope.row, 1)"
          >
            <span slot="reference" class="btn">发布</span>
          </el-popconfirm>
          <el-popconfirm
            title="确定要撤回该条通知公告吗"
            confirm-button-text="继续"
            v-else
            icon="el-icon-info"
            @confirm="issueInformNotice(scope.row, 0)"
          >
            <span slot="reference" class="btn">撤回</span>
          </el-popconfirm>
          <span class="btn" @click="editInfor(scope.row)">编辑</span>
          <el-popconfirm
            title="确定要删除该条通知公告吗"
            confirm-button-text="继续"
            icon="el-icon-info"
            @confirm="deleteInformNotice(scope.row)"
          >
            <span slot="reference" class="btn btn-delete">删除</span>
          </el-popconfirm>
          <!-- <span class="btn btn-delete" @click="deleteInformNotice(scope.row)"
            ></span
          > -->
        </template>
      </el-table-column>
    </el-table>
    <div class="table-page">
      <el-pagination
        background
        layout="prev, pager, next, sizes, jumper"
        :current-page.sync="pageNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getListPage,
  topInformNotice,
  issueInformNotice,
  deleteInformNotice,
  issueBatchInformNotice
} from '@api/announcement/index'
import { getArea } from '@api/activityCenter/activityCenter'
export default {
  data() {
    return {
      open: false,
      deleteVisible: true,
      isDisabled: true,
      entNumber: {
        ids: [],
        isDeploy: 1
      }, // 选中企业数据
      areaList: [],
      IndustryList: [
        { name: '全部', id: '' },
        { name: '已发布', id: 1 },
        { name: '未发布', id: 0 }
      ], // 获取行业列表
      AllDictLabel: [], // 获取所有标签
      ruleform: {
        searchKey: '', // 搜索词
        isDeploy: '', // 发布
        startTime: '', // 开始时间
        endTime: '',
        areaCode: ''
      },
      isCounty: this.$store.state.user.userInfo.roleText,
      timeInterval: '',
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      totalRecord: 0,
      message: {
        createBy: '', // 发送人昵称
        content: '', // 消息内容
        creditCodes: [], // 接受企业
        smsTypes: ['0'], // 推送渠道
        recipients: [] // 接收人
      },
      entNames: [],
      rules: {
        createBy: [
          { required: true, message: '请输入发送人昵称', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入消息内容', trigger: 'blur' }
        ],
        smsTypes: [
          { required: true, message: '请选择推送渠道', trigger: 'change' }
        ],
        recipients: [
          { required: true, message: '请选择接收人', trigger: 'change' }
        ]
      },
      labName: [],
      labCreditCode: '',
      labelIdList: [],
      exportName: '批量发布',
      exportLoading: false,
      noContactEnt: []
    }
  },
  filters: {
    fromt(v) {
      return v.split(' ')[0]
    }
  },
  watch: {
    timeInterval: {
      handler(val) {
        console.log(val)
      },
      deep: true
    }
  },
  computed: {},
  mounted() {
    this.listEnt()
    this.getArea()
    // this.$refs["form"].resetFields();
  },
  methods: {
    /** 获取丽水市以及各个区县 */
    getArea() {
      getArea({}).then(res => {
        if (res.data.code == '0000') {
          this.areaList = res.data.data || []
          this.ruleform.areaCode =
            this.areaList.length == 1 ? this.areaList[0].code : ''
        }
      })
    },
    // 置顶
    topInformNotice(e, status) {
      topInformNotice({ id: e.id, topStatus: status }).then(res => {
        this.pageNum = 1
        this.listEnt()
        this.$message({
          message: status === 0 ? '取消置顶成功' : '置顶成功',
          type: 'success'
        })
      })
    },
    // 发布
    issueInformNotice(e, status) {
      issueInformNotice({ id: e.id, isDeploy: status }).then(res => {
        // this.pageNum = 1
        this.listEnt()
        this.$message({
          message: status === 0 ? '撤回成功' : '发布成功',
          type: 'success'
        })
      })
    },
    // 删除
    deleteInformNotice(e) {
      deleteInformNotice({ id: e.id }).then(res => {
        // this.pageNum = 1
        this.listEnt()
        this.$message({
          message: res.data.msg,
          type: 'success'
        })
      })
    },
    // 新增公告
    addNotice() {
      this.$router.push({ name: 'cementAdd' })
    },
    // 详情
    detailNotice(e) {
      this.$router.push({ name: 'cementDetail', query: { id: e.id } })
    },
    // 编辑
    editInfor(e) {
      this.$router.push({ name: 'cementAdd', query: { id: e.id } })
    },
    // 企业名称
    getSearch() {
      this.pageNum = 1
      this.listEnt()
    },
    // 所有类别
    getPoss() {
      this.pageNum = 1
      this.listEnt()
    },
    //  表格翻页
    handleCurrentChange(pageNum, e) {
      this.pageNum = pageNum
      this.listEnt()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.listEnt()
    },
    // 批量发布
    exportList() {
      issueBatchInformNotice(this.entNumber).then(res => {
        if (res.data.code === '0000') {
          this.pageNum = 1
          this.listEnt()
          this.$message({
            message: res.data.msg,
            type: 'success'
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 列表
    listEnt() {
      let par = { ...this.ruleform }
      par.pageNum = this.pageNum
      par.pageSize = this.pageSize
      if (this.timeInterval) {
        par.startTime = this.timeInterval[0]
        par.endTime = this.timeInterval[1]
      } else {
        par.startTime = ''
        par.endTime = ''
      }

      getListPage(par).then(res => {
        if (res.data.code == '0000') {
          const list = res.data.data
          this.tableData = list.results || []
          this.totalRecord = list.totalRecord || 0
        }
      })
    },
    /**
     * @name:当选择项发生变化时会触发该事件
     * @test: test font
     * @msg:
     * @param {*}
     * @return {*}
     */
    handleSelectionChange(val) {
      this.entNumber.ids = []
      val.map(value => {
        if (value.isDeploy === 0) {
          this.entNumber.ids.push(value.id)
        }
      })

      if (this.entNumber.ids.length >= 2) {
        this.isDisabled = false
      } else {
        this.isDisabled = true
      }
    },
    // 联系企业
    enterprise(val) {
      if (val) {
        this.entNames.push(val.entName)
        this.message.creditCodes.push(val.creditCode)
      } else {
        const list = this.$refs.multipleTable.selection
        if (!list.length) {
          this.$message('请选择要联系的企业')
          return false
        } else {
          list.forEach(ele => {
            this.entNames.push(ele.entName)
            this.message.creditCodes.push(ele.creditCode)
          })
        }
      }

      this.dialogVisible = true
    },

    // 企业详情
    deleteEntTrain(creditCode) {
      this.$router.push({
        name: 'entDetail',
        query: { creditCode: creditCode }
      })
    },
    /** 关闭联系企业清空弹窗 */
    handleClose() {
      this.entNames = []
      this.$refs['message'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  }
  .el-dialog__body {
    height: 500px;
    overflow: auto;
    padding: 30px 60px 20px;
    font-size: 16px;
    & > div {
      & > div {
        margin-bottom: 20px;
        .texthide {
          width: auto;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap;
        }
        .textshow {
          span {
            width: auto;
          }
        }
        &:nth-child(1) {
          display: flex;
          > span {
            display: inline-block;
          }
          span {
            font-size: 14px;
            color: #1890ff;
          }
        }
      }
    }
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.3);
  }
}
/deep/.el-range-separator {
  width: 20px;
}
.header {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  .header-serach {
    .el-input {
      width: 300px;
      margin-right: 30px;
    }
  }
  .addPru {
    height: 36px;
  }
}
.btn {
  color: #1890ff;
  margin-right: 10px;
  cursor: pointer;
}
.btn-delete {
  color: #f00;
}
.cement_title {
  div {
    color: #f00;
    display: inline-block;
    padding: 0 5px;
    border: 1px solid #f00;
    border-radius: 5px;
  }

  width: 100%;
  color: #1890ff;
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  white-space: nowrap;
  cursor: pointer;
}
.container-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  font-size: 16px;
  b {
    color: #1890ff;
  }
  .container-btn {
    margin-top: -10px;
  }
}
.changeAppeal {
  cursor: pointer;
  color: #1890ff;
}
.el-table::before {
  height: 0px;
}
.table-page {
  width: 100%;
  // display: flex;
  // justify-content: space-between;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 20px;
  .choice {
    font-size: 14px;
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.6);
    > div {
      cursor: pointer;
      padding: 10px;
      border: 1px solid;
      border-radius: 4px;
      margin-left: 15px;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 300px;
}
</style>
